import { GOOGLE_ANALYTICS_ID, isGoogleAnalyticsEnabled } from 'config';
import { FC, Fragment, useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { useOrgIdSelector } from 'store/selectors/organizationSelectors/orgSettingsSelector';
import { useUserSelector } from 'store/selectors/userSelectors/userSelector';

if (isGoogleAnalyticsEnabled) {
  ReactGA.initialize(GOOGLE_ANALYTICS_ID);
}

export const GoogleAnalyticsContainer: FC = () => {
  const location = useLocation();
  const user = useUserSelector();
  const orgId = useOrgIdSelector();
  const username = user?.email?.split('@')[0] ?? null;

  useEffect(() => {
    if (!isGoogleAnalyticsEnabled) return;
    ReactGA.gtag('set', 'user_properties', {
      username,
      organization_id: orgId,
    });
  }, [username, orgId]);

  useEffect(() => {
    if (!isGoogleAnalyticsEnabled) return;
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location.pathname]);

  return <Fragment />;
};
